import { render, staticRenderFns } from "./GoodsSettingCustomBuyBtn.vue?vue&type=template&id=b7b74ef8&scoped=true&"
import script from "./GoodsSettingCustomBuyBtn.vue?vue&type=script&lang=js&"
export * from "./GoodsSettingCustomBuyBtn.vue?vue&type=script&lang=js&"
import style0 from "./GoodsSettingCustomBuyBtn.vue?vue&type=style&index=0&id=b7b74ef8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7b74ef8",
  null
  
)

export default component.exports